import React from 'react'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import useSWR from 'swr'
import { buildCacheKey } from '../../util'
import { ExpenseDetail } from '../../components'
import api from '../../api'
import { INewExpense } from '../../typings/entities/expense'
import { PageHeader } from 'antd'

const ExpenseDetailPage: React.FC = () => {
	const params = useParams<{ expenseID: string }>()
	const history = useHistory()
	const location = useLocation()
	const cacheKey = buildCacheKey('expense', 'discrete', {
		documentID: params.expenseID,
	})

	const { data } = useSWR<INewExpense>(cacheKey, async () => {
		try {
			const response = await api.get(`/expenses/${params.expenseID}`)
			return response.data.data
		} catch (error) {
			console.error(error)
			return undefined
		}
	})

	if (!data) return <div>Cargando...</div>

	return (
		<>
			<PageHeader
				title=' '
				onBack={(e) => {
					e.preventDefault()
					const pathnameArray = location.pathname.split('/')
					history.push(
						pathnameArray.slice(0, pathnameArray.length - 1).join('/')
					)
				}}
			/>
			<ExpenseDetail {...data} />
		</>
	)
}

export default ExpenseDetailPage
